module.exports = __webpack_public_path__ + "static/img/devSetting.0bb1bb71.png";